import Feature from 'ol/Feature';
import Collection from 'ol/Collection';
import { Style, Stroke } from 'ol/style';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import WKT from 'ol/format/WKT';

export default {
  methods: {
    addUldkParcelLayer() {
      const feature = new Feature({});
      const features = new Collection();
      features.push(feature);
      const uldkParcelLayer = new VectorLayer({
        id: 'uldkParcelLayer',
        source: new VectorSource({
          features,
        }),
        zIndex: 10000,
        visible: true,
        style: new Style({
          stroke: new Stroke({
            color: 'rgba(191, 54, 12, 1)',
            width: 2,
          }),
        }),
      });
      this.map.addLayer(uldkParcelLayer);
      uldkParcelLayer.feature = feature;
    },
    addUldkParcelToMap(parcel) {
      const layer = this.getLayerById('uldkParcelLayer');
      if (!layer) {
        this.addUldkParcelLayer();
      }
      let wktText = parcel;
      if (wktText.indexOf(';') >= 0) {
        wktText = wktText.split(';')[1];
      }
      const feature = new WKT().readFeature(wktText, {
        dataProjection: this.$_config.defaultEpsg,
        featureProjection: this.$_config.defaultEpsg,
      });
      const geometry = feature.getGeometry();
      if (geometry) {
        const layer = this.getLayerById('uldkParcelLayer');
        if (layer) {
          layer.feature.setGeometry(geometry);
        }
        this.$root.$emit('fitView', geometry);
      }
    },
    clearUldkParcel() {
      const layer = this.getLayerById('uldkParcelLayer');
      if (layer) {
        layer.feature.setGeometry(null);
      }
    },
  },
  mounted() {
    this.$root.$off('addUldkParcelToMap');
    this.$root.$off('clearUldkParcel');
    this.$root.$on('addUldkParcelToMap', this.addUldkParcelToMap);
    this.$root.$on('clearUldkParcel', this.clearUldkParcel);
  },
};
